import axios from "axios";
import nprogress from "nprogress";
import "nprogress/nprogress.css";

// 跨域认证信息 header 名
const xsrfHeaderName = "Authorization";


const requests = axios.create({
    baseURL: "/api",
    timeout: 5000,
    withCredentials:true,
    xsrfHeaderName:xsrfHeaderName,
    xsrfCookieName:xsrfHeaderName,
    headers:{'Content-Type':'application/x-www-form-urlencoded','X-Requested-With':'xmlhttprequest'}
});


//请求拦截器
requests.interceptors.request.use(
  (config) => {
    nprogress.start();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//响应拦截器
requests.interceptors.response.use(
  (res) => {
    nprogress.done();
    return res;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default requests;